module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "l-content l-contact"
  }, [_c('custom-toolbar', {
    attrs: {
      "backLabel": "Retour"
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "infoContent"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('i', {
    staticClass: "fas fa-building"
  }), _vm._v(" "), _c('div', {
    staticClass: "infoName",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.name)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('i', {
    staticClass: "fas fa-phone"
  }), _vm._v(" "), _c('div', {
    staticClass: "infoName"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.contact.tel
    }
  }, [_vm._v(_vm._s(_vm.contact.tel))])])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('i', {
    staticClass: "fas fa-at"
  }), _vm._v(" "), _c('div', {
    staticClass: "infoName"
  }, [_vm._v(_vm._s(_vm.contact.email))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('i', {
    staticClass: "fas fa-globe"
  }), _vm._v(" "), _c('div', {
    staticClass: "infoName"
  }, [_vm._v(_vm._s(_vm.contact.web))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a693968","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/KeyholdingContact.vue
// module id = 207
// module chunks = 0